import React, { memo } from "react";
import { Button } from "../../Button";
import { useDatePickerContext } from "../DatePickerContext";

import styles from "./styles.module.scss";

export type PredefinedRangeType = {
  label: string,
  getValue: () => [ Date | null, Date | null ]
}

type PropsType = {
  predefinedRanges: PredefinedRangeType[]
}

export const PredefinedDates = memo<PropsType>(({ predefinedRanges }) => {
  const { onChange } = useDatePickerContext();
  
  return (
    <div className={styles.root}>
      {predefinedRanges.map((range) => (
        <Button
          buttonType="tertiaryGray"
          buttonSize="sm"
          key={range.label}
          onClick={() => onChange(range.getValue() as any)}
          className={styles.button}
        >
          {range.label}
        </Button>
      ))}
    </div>
  );
});

export default PredefinedDates;
